<template>
  <div>
    <div id="container"></div>
    <!-- <input type="text" id="lnglat"> -->
  </div>
</template>
<script>
import config from "@/config"
  import AMapLoader from "@amap/amap-jsapi-loader";
	import audio from "@/assets/images/icon_audio.png";
	import audio_selected from "@/assets/images/icon_audio_selected.png";
	import icon_video from "@/assets/images/icon_video.png";
	import icon_video_selected from "@/assets/images/icon_video_selected.png";
	import flag from "@/assets/images/flag-new.png";
	import person from "@/assets/images/person.png";
	import icon_my from "@/assets/images/2GPS.gif";
  let AMap ;
  export default {
    props: {
      showLine: Boolean,
      coord: Array,
      dataList: Array,
      lineList: Array,
      clockId: String|Number,
      mapCenter:String|Number
    },
    watch: {
        'dataList': {
            handler: function(newv,oldv){
                if(newv){
                    if(Array.isArray(newv)){
                      this.markerData = newv;
                      this.$nextTick(()=>{
                        this.ownmap && this.addMarker(newv)
                      })
                    }
                }
            },
            immediate:true
        },
        //开始展示线路规则
      showLine: {
        handler: function(newv,oldv){
          if (newv) {
            this.startAnimation();
            this.coordcenter = [];
          } else {
            this.startAnimation();
            this.stopAnimation();
          }
        }, immediate: true
    },
      lineList: {
        handler: function(newv,oldv){
          if (newv&&newv.length>0) {
              this.lineArr = newv;
              this.moveMarker(that.lineArr);
          } 
        },
        immediate: true
    },
      coord: {
        handler: function(newv,oldv){
          if(newv==oldv||newv.length<=0) return;
          if(newv.length>2){
            let latlng = [newv[0],newv[1]];
            this.coordcenter = this.toAim(latlng);
          }else {
            this.coordcenter = [];
            this.setCenter(newv,'type');
          }
        },
        immediate: true
    },
      clockId: {
        handler: function(newv,oldv){
          if(!newv) return;
          if (newv) {
              this.clockIn(newv);
          }
        },
        immediate: true
    },
    mapCenter:{
      handler:function(newv,oldv){
        if(newv){
          let obj = config.site.find(t=>{return t.spot == parseInt(this.$route.query.spot)})
          if(obj){
            this.setCenter(obj.center)
          }
        }
      },deep:true
    },

    },
    data() {
      return {
        audio,
        audio_selected,
        icon_video,
        icon_video_selected,
        flag,
        person,
        icon_my,
        islabel: false,
        markerList: [],
        markerData: [],
        lineArr: [],
        moveIcon: null,
        ownmap: null,
        coordcenter:[],//个人定位坐标
        mymarker: null,//我的标记点
        curMap:null
      }
    },
    mounted() {
      this.initMap()
    },
    methods: {
      // 初始化地图
			initMap(propData) {
				let that = this;
        let data = that.markerData;
				AMapLoader.load({
					key: "94039c4d237c77e7fbe59c49e2b31446", // 申请好的Web端开发者Key，首次调用 load 时必填
					version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
					plugins: ['AMap.Walking','AMap.Geolocation'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
				}).then((AMap1) => {
          AMap = AMap1
					that.ImageLayer();
				}).catch(e => {
					console.log(e);
				})
			},
      getPic(path){
        if(path.indexOf("/")!=-1){
          let xt = path.split("/")[1]
          return require('@/assets/images/map/'+xt)
        }
        return require('@/assets/images/'+path)
      },
      fixZero(num){
        num=  parseInt(num)
        return num<10?'0'+num:num
      },
			// 图片图层
			ImageLayer() {
        this.curMap = config.site.find(t=>{return t.spot == parseInt(this.$route.query.spot)})
        this.ownmap = new AMap.Map('container', {
					center: this.curMap.center,
					zoom: this.curMap.initZoom,
					zooms: this.curMap.zooms,
          features:[],
					layers: [
						AMap.createDefaultLayer(),
						// imageLayer,
					]
				});
        // 定义限制区域的西南角和东北角坐标
        if(this.curMap.bounds){
          const southWest = new AMap.LngLat(...this.curMap.bounds[0]); // 西南角
          const northEast = new AMap.LngLat(...this.curMap.bounds[1]); // 东北角
          console.log(southWest,northEast)

          const bounds = new AMap.Bounds(southWest, northEast);
          this.ownmap.setLimitBounds(bounds);
        }
        // this.ownmap.setFeatures(['bg', 'road','building']);
        // if(this.curMap.rotate){
        //   this.ownmap.setRotation(this.curMap.rotate)
        // }
        //判断是否为多图拼接
        /** */
        if(this.curMap.mulPic){
          this.curMap.imgCenter.map((t,i)=>{
            var lay = new AMap.ImageLayer({
              url: this.getPic(`${this.curMap.mapPic}_${this.fixZero(i+1)}.gif`),
              bounds: new AMap.Bounds(...t),
              resizeEnable: true, //是否监控地图容器尺寸变化
              mapStyle: "https://amap://styles/whitesmoke"
            });
            this.ownmap.add(lay)
          })
        }else{
          var imageLayer = new AMap.ImageLayer({
            url: this.getPic(this.curMap.mapPic),
            bounds: new AMap.Bounds(...this.curMap.imgCenter),
            // url: 'https://img.hhgsl.org.cn/img/map.png',
            // bounds: new AMap.Bounds(
            // 	[110.14868070099638, 27.341524786075484],
            // 	[110.15308090546965, 27.349780812305705]//27上下 -下+上 110左右 +右 -左
            // ),
            zooms: this.curMap.zooms,
            resizeEnable: true, //是否监控地图容器尺寸变化
            mapStyle: "https://amap://styles/whitesmoke"
          });
          this.ownmap.add(imageLayer)
        }
        
        
        let that = this;
        this.ownmap.on("complete", function(){
           that.addMarker(that.markerData);
           that.ownmap.on('zoomchange', that.mapZoom);
        }); 
			},
      // 缩放事件
      mapZoom(){
        var zoom = this.ownmap.getZoom();
        if(zoom < this.curMap.dotDisableZoom){
          this.ownmap.remove(this.markerList);
          this.markerList = [];
        }else {
          this.markerList.length<=0&&this.addMarker(this.markerData,'zoom');
        }
      },
			// 添加定位点
			addMarker(data,type) {
				let that = this;
				let map = this.ownmap;
        console.log("添加点",data.length)
				if (this.markerList != undefined && this.markerList.length != 0) {
					map.remove(this.markerList);
					this.markerList = [];
				}
				if (data.length == 0) {
					return;
				}
				let markers = [];
        // let center=data[0].coordinate;
        let center;
				data.forEach((item, index) => {
					var lng_arr = item.coordinate;
					var lng = lng_arr[0];
					var lat = lng_arr[1];
					var marker = new AMap.Marker({
						icon: "0",
            zooms: [12,20],
            zoom: 18,
						position: new AMap.LngLat(lng, lat),
						offset: new AMap.Pixel(0, 0),
						extData: {
							picid: item.id,
							indexnumber: index,
							lng: lng,
							lat: lat,
              name: item.name,
              creator:item.creator,
              media_path: item.media_path,
              services: item.services,
						},
					});
          let domstr='';
          if(item.checked || (this.oldMarkObj && this.oldMarkObj.picid == item.id)){
            center = item.coordinate;
            if(item.creator=='1' || item.creator==1){
              domstr += "<div class='infolabel active clocked'>";
              domstr += "<em>"+(index+1)+"</em><span class='label'>" + item.name + "</span>";
              if(item.media_path){domstr += "<img src=" + that.audio_selected +" />";}
              if(item.services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video_selected +" />";}
              domstr += "</div>";
          } else{
            domstr += "<div class='infolabel active'>";
            domstr += "<em>"+(index+1)+"</em><span class='label'>" + item.name + "</span>";
            if(item.media_path){domstr += "<img src=" + that.audio_selected +" />";}
            if(item.services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video_selected +" />";}
            domstr += "</div>";
          }
          }else if(item.creator=='1' || item.creator==1){
            domstr += "<div class='infolabel clocked'>";
            domstr += "<em>"+(index+1)+"</em><span class='label'>" + item.name + "</span>";
            if(item.media_path){domstr += "<img src=" + that.audio +" />";}
            if(item.services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video +" />";}
            domstr += "</div>";
          } else{
            domstr += "<div class='infolabel'>";
            domstr += "<em>"+(index+1)+"</em><span class='label'>" + item.name + "</span>";
            if(item.media_path){domstr += "<img src=" + that.audio +" />";}
            if(item.services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video +" />";}
            domstr += "</div>";
          }
          marker.setLabel({
						direction: 'right',
						offset: new AMap.Pixel(-20, 0), //设置文本标注偏移量
						content: domstr,
					});
					// 将 markers 添加到地图
					map.add(marker);
					markers.push(marker);
					markers.map((t) => {
						t.on("click", that.markClick);
					});
				})
				that.ownmap = map;
        // that.ownmap.setZoom(18,true);//设置地图缩放比例
				that.markerList = markers;
        if(type) return;
        
        // let time = setTimeout(() => {
        //   if(center){
        //       that.setCenter(center);//设置中心点
        //   }
        //   else if(!center&&that.coordcenter.length>0){
        //     that.setCenter(that.coordcenter,'type');
        //   }
        //   else{
        //     that.setCenter(data[14].coordinate);//设置中心点
        //   }
        //   clearTimeout(time);
        // }, 1500);
			},
      // 点击事件
      markClick(e) {
        if(!e.target._opts.extData.picid) return;
        //获取当前点击的标记值
        let index = e.target._opts.extData.picid;
        this.oldMarkObj = e.target._opts.extData
        let that = this;
        // 将所有标记点与当前编辑点匹配，相同则放大图标，
        // 不同则设置为初始值（将其余被放大的标记点复原）
        this.markerList.forEach((markeritem,i) => {
          let index2 = markeritem._opts.extData.picid;
          let cname = markeritem._opts.extData.name;
          let cindex = markeritem._opts.extData.indexnumber;
          let creator = markeritem._opts.extData.creator;
          let media_path = markeritem._opts.extData.media_path;
          let services = markeritem._opts.extData.services;
          let domstr = '';
          if (index === index2) {
            // 相同-变色
            if(creator=='1' || creator==1){
              domstr += "<div class='infolabel active clocked'>";
              domstr += "<em>"+(cindex+1)+"</em><span class='label'>" + cname + "</span>";
              if(media_path){domstr += "<img src=" + that.audio_selected +" />";}
              if(services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video_selected +" />";}
              domstr += "</div>";
            }else{
              domstr += "<div class='infolabel active'>";
              domstr += "<em>"+(cindex+1)+"</em><span class='label'>" + cname + "</span>";
              if(media_path){domstr += "<img src=" + that.audio_selected +" />";}
              if(services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video_selected +" />";}
              domstr += "</div>";
            }
            e.target.setzIndex(1000);//设置层级-高
          } else {
            markeritem.setzIndex(cindex+1);//设置层级-复原
            // 不同-复原
            if(creator=='1' || creator==1){
              domstr += "<div class='infolabel clocked'>";
              domstr += "<em>"+(cindex+1)+"</em><span class='label'>" + cname + "</span>";
              if(media_path){domstr += "<img src=" + that.audio +" />";}
              if(services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video +" />";}
              domstr += "</div>";
              // markeritem.setLabel({
              //   direction: 'right',
              //   // offset: new AMap.Pixel(-55, -30), //设置文本标注偏移量
              //   offset: new AMap.Pixel(-20, 0), //设置文本标注偏移量
              //   content: "<div class='infolabel clocked'><em>"+(cindex+1)+"</em><span class='label'>" + cname + "</span><img src=" + that.audio +" /></div>", //设置文本标注内容
              // });
            }else{
              domstr += "<div class='infolabel'>";
              domstr += "<em>"+(cindex+1)+"</em><span class='label'>" + cname + "</span>";
              if(media_path){domstr += "<img src=" + that.audio +" />";}
              if(services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video +" />";}
              domstr += "</div>";
              // markeritem.setLabel({
              //   direction: 'right',
              //   // offset: new AMap.Pixel(-55, -30), //设置文本标注偏移量
              //   offset: new AMap.Pixel(-20, 0), //设置文本标注偏移量
              //   content: "<div class='infolabel'><em>"+(cindex+1)+"</em><span class='label'>" + cname + "</span><img src=" + that.audio +" /></div>", //设置文本标注内容
              // });
            }
          }
          markeritem.setLabel({
            direction: 'right',
            offset: new AMap.Pixel(-20, 0), //设置文本标注偏移量
            content: domstr, //设置文本标注内容
          });
        });
        this.$emit("markclick", { id: index });
      },
      // 步行规划
      amapwalk(){
        let that = this;
         var walkOption = {
          map: that.ownmap,
          panel: "panel",
          hideMarkers: false,
          isOutline: true,
          outlineColor: '#ffeeee',
          autoFitView: true
      }

      // 步行导航
      var walking = new AMap.Walking(walkOption)

      //根据起终点坐标规划步行路线
      walking.search([110.14868070099638, 27.341524786075484], [110.15303089546965, 27.349738912304624], function(status, result) {
          // result即是对应的不行路线数据信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_RidingResult
          if (status === 'complete') {
              console.log('步行路线数据查询成功')
          } else {
              console.log('步行路线数据查询失败' + result)
          } 
      });
      },
      // 轨迹回放
      moveMarker(data){
        let that = this;
        AMap.plugin('AMap.MoveAnimation', function(){
          var marker = that.moveIcon, 
          lineArr = that.lineArr;
          var person_icon = new AMap.Icon({
            size: new AMap.Size(26, 48),
            image: that.person,
            imageSize: new AMap.Size(26, 48)
          })
          marker = new AMap.Marker({
            map: that.ownmap,
            position: lineArr[0],
            zoom: 18,
            zooms: [16,20],
            icon: "0",
            // icon: person_icon,
            offset: new AMap.Pixel(-13, -26),
          });
          let markers = [];

          markers.push(marker);

          // 绘制轨迹
          var polyline = new AMap.Polyline({
              map: that.ownmap,
              path: lineArr,
              showDir:false,
              strokeColor: "#28F",  //线颜色
              strokeOpacity: 0,     //线透明度
              strokeWeight: 6,      //线宽
              // strokeStyle: "solid"  //线样式
          });

          var passedPolyline = new AMap.Polyline({
              map: that.ownmap,
              showDir:true,
              // strokeColor: "#AF5",  //线颜色
              // strokeColor: "#28F",
              strokeColor: "#00EDFF",
              // strokeWeight: 6,      //线宽
              strokeWeight: 7,      //线宽
          });


          marker.on('moving', function (e) {
              passedPolyline.setPath(e.passedPath);
              // that.ownmap.setCenter(e.target.getPosition(),true)
              // that.ownmap.setZoom(18,true);//设置地图缩放比例
              // that.setCenter(e.target.getPosition());//设置中心点
              if(e.pos.lng==lineArr[(lineArr.length)-1][0]){
                // marker.setPosition(lineArr[0]);
                // // that.ownmap.setCenter(e.target.getPosition(),true)
                // that.setCenter(e.target.getPosition());//设置中心点
                // // marker.moveTo(lineArr[0],300)
                that.ownmap.remove(markers);
                return;
              }
          });

          that.ownmap.setFitView();

          that.moveIcon = marker;
          // that.startAnimation();
      });
      },
      // 轨迹回放 - 开始
      startAnimation(){
        this.moveIcon&&this.ownmap.setCenter([110.150956,27.345],true)
        this.moveIcon&&this.ownmap.setZoom(16.8,true);//设置地图缩放比例
        var marker = this.moveIcon, 
          lineArr = this.lineArr;
        this.moveIcon&&marker.moveAlong(lineArr, {
            // 每一段的时长
            duration: 500,//可根据实际采集时间间隔设置
            // JSAPI2.0 是否延道路自动设置角度在 moveAlong 里设置
            autoRotation: true,
        });
      },
      // 轨迹回放 - 暂停
      pauseAnimation(){
        this.moveIcon&&this.moveIcon.pauseMove();
      },
      // 轨迹回放 - 继续
      resumeAnimation(){
        this.moveIcon&&this.moveIcon.resumeMove();
      },
      // 轨迹回放 - 停止
      stopAnimation(){
        this.moveIcon&&this.moveIcon.stopMove();
      },
      //打卡
      clockIn(id){
        let that = this;
        that.ownmap.setZoom(19,true);//设置地图缩放比例
        that.markerList.forEach((markeritem,i) => {
          let index2 = markeritem._opts.extData.picid;
          let cname = markeritem._opts.extData.name;
          let cindex = markeritem._opts.extData.indexnumber;
          let creator = markeritem._opts.extData.creator;
          let media_path = markeritem._opts.extData.media_path;
          let services = markeritem._opts.extData.services;
          let domstr = '';
          if (id === index2) {
            // 相同-变色
              domstr += "<div class='infolabel active clocked-falg'>";
              domstr += "<em>"+(cindex+1)+"</em><span class='label'>" + cname + "</span>";
              if(media_path){domstr += "<img src=" + that.audio_selected +" />";}
              if(services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video_selected +" />";}
              domstr += "</div>";
            markeritem._opts.extData.creator=1;
            markeritem.setzIndex(1000);//设置层级-高
            that.ownmap.setCenter(new AMap.LngLat(markeritem._opts.extData.lng, markeritem._opts.extData.lat),true);//设置地图中心点
          } else {
            markeritem.setzIndex(cindex+1);//设置层级-复原
            // 不同-复原
            if(creator=='1' || creator==1){
              domstr += "<div class='infolabel clocked'>";
              domstr += "<em>"+(cindex+1)+"</em><span class='label'>" + cname + "</span>";
              if(media_path){domstr += "<img src=" + that.audio +" />";}
              if(services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video +" />";}
              domstr += "</div>";
            }else{
              domstr += "<div class='infolabel'>";
              domstr += "<em>"+(cindex+1)+"</em><span class='label'>" + cname + "</span>";
              if(media_path){domstr += "<img src=" + that.audio +" />";}
              if(services=='1'){domstr += "<img class='mp4_img' src=" + that.icon_video +" />";}
              domstr += "</div>";
            }
          }
          markeritem.setLabel({
            direction: 'right',
            offset: new AMap.Pixel(-20, 0), //设置文本标注偏移量
            content: domstr, //设置文本标注内容
          });
        });
        
      },
      // 设置中心点
      setCenter(centerlng,type){
        let that = this;
        if(!that.ownmap) return;
        that.ownmap.setCenter(centerlng,true);//设置地图中心点
        !type&&that.ownmap.setZoom(17.5,true);//设置地图缩放比例
        if(type){   
          that.mymarker&&that.ownmap.remove(that.mymarker);       
          let lng = centerlng[0];
          let lat = centerlng[1];
          var my_icon = new AMap.Icon({
            size: new AMap.Size(54, 54),
            image: that.icon_my,
            imageSize: new AMap.Size(54, 54)
          })
          that.mymarker = new AMap.Marker({
            id: 999,
            position: new AMap.LngLat(lng,lat),
            icon: my_icon,
            offset: new AMap.Pixel(-27,-54)
          })
          that.ownmap.add(that.mymarker);
          that.ownmap.setZoom(18.5,true);
        }
      },
      // 点击获取坐标
      getCoor(){
        let map = this.ownmap;
        map.on('click', function(e) {
                document.getElementById("lnglat").value = e.lnglat.getLng() + ',' + e.lnglat.getLat()
            });
      },
      // 当前位置是否在景区范围内
      toAim(res){
        let longitude = [110.14868070099638,110.15308090546965]
        let latitude = [27.341524786075484,27.349780812305705]
        if(res.length<=0) return;
              let xt = res;
              xt.sort((a,b)=>{
                return b-a
              })
              if(xt[1]>= latitude[0] && 
              xt[1] <= latitude[1] && 
              xt[0] >=longitude[0] && 
              xt[0]<=longitude[1] ){
                console.log("在景区 ");
                return xt;
              }else{
                console.log("您不在景区范围内 ");
                return [];
              }
         
      },

  
    },
    destroyed() {
      // 销毁地图
      // this.ownmap && this.ownmap.destroy();
    },
  }
</script>
<style lang="scss" scoped>
    #container{
      padding: 0;
      margin: 0;
      width: 100%;
      height: calc(100vh - 0.5rem );
    }

    // #lnglat{
    //   position: fixed;
    //   bottom: 100rem;
    //   left: 30rem;
    //   height: 40rem;
    //   border: 1px solid #ccc;
    //   background: #fff;
    //   z-index: 10;
    // }

</style>